export const FinancialType = {
  IFinancialInstallmentsService: Symbol("IFinancialInstallmentsService"),
  IDownloadFinancialInstallmentsService: Symbol(
    "IDownloadFinancialInstallmentsService"
  ),
  IFinancialFiltersService: Symbol("IFinancialFiltersService"),
  IChartDataService: Symbol("IChartDataService"),
};
